export default "data:image/webp;base64,UklGRkwAAABXRUJQVlA4TEAAAAAvJ4AGAAZFAUBGFfhKQj8F1bptP4QaGDe9FZHJJPIgyLaxGMI8DnGw58L9nwA736C6bkVj7vTmQIlbqDid3hwA"